<template>
    <div>
        <div class="modal hide fade" id="modalCustomerForm" tabindex="-1" role="dialog" aria-labelledby="modalCustomerForm" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Customer
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.name" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="group_id" class="col-sm-3 col-form-label text-left">Group</label>
                                    <div class="col-sm-9">
                                        <select v-model="customer.group_id" class="form-control">
                                            <option value="1">Individual</option>
                                            <option value="2">Company</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="email" class="col-sm-3 col-form-label text-left">Email</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" v-model="customer.email"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.phone" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
                                    <div class="col-sm-9">
                                        <textarea rows="5" v-model="customer.address" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="state_id" class="col-sm-3 col-form-label text-left">State</label>
                                    <div class="col-sm-9">
                                        <select v-model="customer.state_id" class="form-control">
                                            <option v-for="c in stateList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="city_id" class="col-sm-3 col-form-label text-left">City</label>
                                    <div class="col-sm-9">
                                        <select v-model="customer.city_id" class="form-control">
                                            <option v-for="c in cityList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="identity_number" class="col-sm-3 col-form-label text-left">No. KTP</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.identity_number" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="birthday" class="col-sm-3 col-form-label text-left">Birthday</label>
                                    <div class="col-sm-9">
                                        <datetime v-model="customer.birthday" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="birthday" class="col-sm-3 col-form-label text-left">Birth Place</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.birthplace" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="twitter" class="col-sm-3 col-form-label text-left">Twitter</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.twitter" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="facebook" class="col-sm-3 col-form-label text-left">Facebook</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.facebook" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="instagram" class="col-sm-3 col-form-label text-left">Instagram</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.instagram" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="vat" class="col-sm-3 col-form-label text-left">VAT</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.vat" class="form-control"/>
                                    </div>
                                </div>
                            </div>
                            <!-- <pre>{{ customer }}</pre> -->
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" data-dismiss="modal" @click="save">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import { customerUrl, getHeader } from '../../config'
export default {
  name: 'CustomerFormModal',
  data () {
    return {
      money: {
        total: '0',
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      customer: {
        id: null,
        customer_no: null,
        name: null,
        group_id: 1,
        email: null,
        phone: null,
        address: null,
        city_id: null,
        state_id: null,
        identity_number: null,
        vat: null,
        birthday: null,
        birthplace: null,
        twitter: null,
        facebook: null,
        instagram: null
      }
    }
  },
  computed: {
    ...mapState({
      cityList: state => state.city.cityList,
      stateList: state => state.state.stateList
    })
  },
  methods: {
    selectCustomer (value) {
      var customer = this.customer
      customer.id = value.id
      customer.customer_no = value.customer_no
      customer.name = value.name
      customer.group_id = value.group_id
      customer.email = value.email
      customer.phone = value.phone
      customer.address = value.address
      customer.city_id = value.city_id
      customer.state_id = value.state_id
      customer.identity_number = value.identity_number
      customer.vat = value.vat
      customer.birthday = value.birthday
      customer.birthplace = value.birthplace
      customer.twitter = value.twitter
      customer.facebook = value.facebook
      customer.instagram = value.instagram
    },
    save: function () {
      axios.post(customerUrl, this.customer, { headers: getHeader() })
        .then(response => {
          this.$emit('createCustomer', response.data.data)
        })
        .catch(error => {
          console.log(error.response)
        })
    }
  },
  mounted () {
    this.$store.dispatch('getStateList')
    this.$store.dispatch('getCityList')
  }
}
</script>
